<template>
  <header class="header">
    <div class="header__inner">
      <div class="header__top">
        <div class="header__top__left" v-show="showSignature">
          <TheHeaderSignature />
        </div>
        <div class="header__top__right">
          <TheHeaderToggle />
        </div>
      </div>
      <TheHeaderMenu />
    </div>
  </header>
</template>

<script>
import TheHeaderToggle from './TheHeaderToggle'
import TheHeaderMenu from './TheHeaderMenu'
import TheHeaderSignature from './TheHeaderSignature'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderSignature,
    TheHeaderToggle,
    TheHeaderMenu
  },
  computed: {
    showSignature () {
      return this.$route.name !== 'home'
    }
  }
}
</script>

<style lang="scss">
.header {
  @include container(get($layout, "full-width"));
  position: fixed;
  left: 50%;
  top: 0;
  z-index: 125;
  transform: translateX(-50%);

  // Inner

  &__inner {
    // @include inner;
    width: 100%;
    height: 100%;
    position: relative;
  }

  // Top

  &__top{
    @include media("small-medium"){
      padding: layout("spacing")/2;
    }
    @include media("large"){
      padding: layout("spacing");
    }
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__left{

    }

    &__right{
      margin-left: auto;
    }
  }

  // Header Menu

  .header-menu{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 100vh;
  }

}
</style>
